module.exports = __webpack_public_path__ + "static/media/131.36974e57.jpg";